module.exports = __webpack_public_path__ + "img/stretch--genre2_tab-normal.cb0ce19b.png";